import { EXPORT_STATUS_SUBSCRIPTION } from "queries/neoactivite/neoactivite";
import { clientNeoActiviteWS } from "@neonumy/api-clients";
import { useSubscription } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Progress, Space, Typography } from "antd";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const { Text } = Typography;

export default function ProgressExport({ bookEntriesType }: { bookEntriesType: string }) {
  const { t } = useTranslation();
  const { companyId } = useParams();

  const { data } = useSubscription<GenericSubscriptionResponse, GenericSubscriptionVars>(
    EXPORT_STATUS_SUBSCRIPTION,
    {
      client: clientNeoActiviteWS,
      variables: { id: `export_status:${companyId}_${bookEntriesType}` },
    },
  );

  const percentage = data?.genericSubscription?.percentage;
  const textStatus = data?.genericSubscription?.info;

  if (!percentage && !textStatus) return null;

  return (
    <div className="fact-progress-export">
      {percentage && (
        <Progress
          className="fact-progress-export__progress"
          percent={percentage}
          status="active"
          strokeColor={{ from: "#3e849e", to: "#356f85" }}
        />
      )}
      {textStatus && (
        <Space size={6} align="center">
          <AiOutlineLoading3Quarters className="fact-progress-export__spinner" />
          <Text className="fact-progress-export__status" type="secondary">
            {t("Status")}: {textStatus}
          </Text>
        </Space>
      )}
    </div>
  );
}
